<template>
    <div class="dm-previously-published-books">
        <div class="mb-4">
            <PreviousBook
                v-for="(prize, index) in previous_published_books"
                :previous_book="previous_published_books[index]"
                :index="index"
                :key="'previous-book-' + index"
                @booksUpdated="$emit('booksUpdated')"
                @remove="remove(index)"
            />
        </div>

        <button
            class="btn btn-success dm-add-new-previous-book"
            @click="addNew()"
        >
            {{ translate("Add") }}
        </button>
    </div>
</template>

<script>
import PreviousBook from "./partials/PreviousBook.vue";

export default {
    components: { PreviousBook },

    props: ["previous_published_books"],

    methods: {
        addNew() {
            let blankBook = {
                title: "",
                publisher: "",
                year: "",
            };
            this.previous_published_books.push(blankBook);
        },
        remove(index) {
            this.previous_published_books.splice(index, 1);
            this.$emit("booksUpdated");
        },
    },
};
</script>
